import React, { Component } from 'react';
import Helping from "../../helpers/Helping";
import Notification from "../layout/Notification";
import { setErrorFields, validateField } from "../../helpers/validationHelpers";
import route from '../../config/routes';
import { MESSAGE } from '../../config/index';
import { API_URL } from '../../config/urls';
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import LoadingButton from '../layout/Loader';
import Service from '../../helpers/service';
import { connect } from 'react-redux';

const { EMPTY, IMPORT } = MESSAGE;
class Import extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            url: API_URL.ADMIN_TRADING_API + route.IMPORT_ITEMS,
            routeName: route.IMPORT_NFT,
            error_message: '',
            error_type: '',
            isLoading: true,
            btnIsDisable: false
        };

        this.onSave = this.onSave.bind(this);
    }

    componentDidMount() {
        this.setState({ isLoading: false });
        this.props.addCurrentRoute(this.props.profile, this.props.location.pathname);
    }

    handleChange = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === "items") this.setState({ ...await validateField("string", name, value, "", 3) });
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    checkEmptyFields = () => {
        let { state } = this,
            formHasError = false;

        if (state.items.length === 0) {
            let errorObject = setErrorFields("items", Helping.getMessageString(EMPTY, "Items"));
            this.setState({ ...errorObject });
            formHasError = true;
        }
        return formHasError;
    }

    onSave(e) {
        e.preventDefault();

        let $this = this,
            formHasError = this.checkEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true
        });

        let data = {
            action: 'import',
            items: JSON.parse($this.state.items),
        };

        Service.postCall(this.state.url, data).then(response => {
            if (response.data.status === 200) {
                this.setState(
                    {
                        error_message: Helping.getMessageString(IMPORT, "NFT"),
                        error_type: "success",
                        btnIsDisable: false
                    }, () => { this.scrollToTop(); }
                );
            }
        }).catch(error => {
            if (error.response) {
                Helping.redirectToLogin(error);
                return $this.setState({
                    error_message: error.response.data.message,
                    error_type: 'danger',
                    btnIsDisable: false
                }, () => { this.scrollToTop(); });
            }
            return this.setState({
                isLoading: false,
                btnIsDisable: false,
                ...Helping.setNetworkRequestError(error, "importing nft")
            }, () => { this.scrollToTop(); })
        });
    }

    resetForm = () => {
        this.setState({
            items: [],
            error_type: "",
            error_message: "",
            error_items_message: "",
            btnIsDisable: false
        })
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    render() {
        return (
            <div class="content nft-form">
                <div class="top-header d-block">
                    <div class="header-title">
                        <h2 class="title">Import NFTs</h2>
                        <span class="title-caption">You can import your nfts now.</span>
                    </div>
                </div>
                <div class="main-content">
                    {this.state.error_message &&
                        <Notification
                            type={this.state.error_type}
                            message={this.state.error_message}
                            callback={this.removeNetworkError}
                        />
                    }
                    <form action="" class="importNFT-form">
                        <div class="form-group">
                            <label for="importnft">Items</label>
                            <textarea class={`form-control ${this.state.error_items_message ? 'error-input' : ''}`} rows={20} name="items" id="importnft" onChange={(e) => this.handleChange(e)}></textarea>
                            <span className="error-msg">{this.state.error_items_message}</span>
                        </div>

                        <div class="content-btn">
                            <button type="reset" class="custom-btn sm-btn semi-dark-btn border-btn" onClick={this.resetForm}>Reset</button>
                            {this.state.btnIsDisable ?
                                <LoadingButton class_name={"sm-btn"} />
                                :
                                <button type="submit" class="custom-btn sm-btn gradiant-btn" onClick={(e) => this.onSave(e)}>{this.state.btnIsDisable ? "Loading..." : "Save"}</button>
                            }
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = {
    addCurrentRoute
}

export default connect(null, mapDispatchToProps)(Import)